import { invoke } from '@tauri-apps/api/core';

import type { WatcherStatusInfo } from '../types';
import { GDT_COMMAND_PREFIX as COMMAND_PREFIX } from './constants';

/**
 * Start the GDT file watcher.
 *
 * Begins polling the configured input folder for incoming .gdt files.
 * The watcher auto-starts on app launch if GDT is configured, so this
 * is mainly used after stopping/restarting or reconfiguring.
 *
 * @throws Error if watcher is already running or config is invalid
 */
export async function gdtStartWatcher(): Promise<void> {
  await invoke<void>(`${COMMAND_PREFIX}start_gdt_watcher`);
}

/**
 * Stop the GDT file watcher.
 *
 * Gracefully cancels the background polling task.
 *
 * @throws Error if watcher is not running
 */
export async function gdtStopWatcher(): Promise<void> {
  await invoke<void>(`${COMMAND_PREFIX}stop_gdt_watcher`);
}

/**
 * Get current GDT watcher status.
 *
 * Returns status info including whether it's running, files processed count,
 * and last error if any.
 *
 * @returns Current watcher status
 */
export async function gdtGetWatcherStatus(): Promise<WatcherStatusInfo> {
  return invoke<WatcherStatusInfo>(`${COMMAND_PREFIX}get_gdt_watcher_status`);
}
